module.exports = __webpack_public_path__ + "img/video.06b1b340.svg";